export const GET_CLUBS_SA = `
query($term: String, $skip: Int, $limit: Int) {
  getClubsSA(term: $term, skip: $skip, limit: $limit) {
    _id
    name
    abbreviation
    logo
    clubAdminUsers
    location {
      address
      coordinates
    }
    founded
    country
    sport
    contactInfo {
      phones
      emails
      websiteUrl
    }
    isPremium
    timezone
  }
}`;

export const IS_PREMIUM = `
mutation ToggleIsPremiumSA($clubId: String!, $isPremium: String!) {
  toggleIsPremiumSA(clubId: $clubId, isPremium: $isPremium) {
    _id
    name
    abbreviation
    logo
    location {
      address
      coordinates
      type
    }
    founded
    clubAdminUsers
    country
    sport
    contactInfo {
      phones
      emails
      websiteUrl
    }
    isPremium
    timezone
  }
}
`;

export const EDIT_CLUB = `
mutation editClub(
  $clubId: String!,
  $name: String,
  $abbreviation: String,
  $founded: Int,
  $country: String,
  $sport: String,
  $isPremium: String,
  $timezone: String
  ) {
  editClub(
    clubId: $clubId,
    name: $name,
    abbreviation: $abbreviation,
    founded: $founded,
    country: $country,
    sport: $sport,
    isPremium: $isPremium,
    timezone: $timezone
  ) {
    _id
    name
    abbreviation
    logo
    location {
      address
      coordinates
      type
    }
    founded
    clubAdminUsers
    country
    sport
    contactInfo {
      phones
      emails
      websiteUrl
    }
    isPremium
    timezone
  }
}
`;

export const CREATE_CLUB_SA = `
  mutation createClubSA($name: String!, $abbreviation: String, $founded: Int, $country: String!, $sport: String!, $contactInfo: ContactInfoInput, $location: LocationInput, $timezone: String) {
    createClubSA(name: $name, abbreviation: $abbreviation, founded: $founded, country: $country, sport: $sport, contactInfo: $contactInfo, location: $location, timezone: $timezone) {
      _id
    }
  }
`;

export const REGISTER_USER_SA = `
 mutation RegisterUserSa($firstName: String!, $lastName: String, $mobile: String!, $email: String, $role: String!, $clubId: String, $teamId: String) {
    RegisterUserSa(firstName: $firstName, lastName: $lastName, mobile: $mobile, email: $email, role: $role, clubId: $clubId, teamId: $teamId) {
      _id
    }
  }
`;

export const REMOVE_CLUB_ADMIN_SA = `
 mutation RemoveClubAdmin($clubId: String, $userId: String, $deleteUser: Boolean) {
    removeClubAdmin(clubId: $clubId, userId: $userId, deleteUser: $deleteUser)
  }
`;

const PROFILE_WITH_INVITATIONS = `
    fragment profileWithInvitation on ProfileWithInvitations {
     _id
    firstName
    lastName
    mobile
    club 
    teams
    yearOfBirth
    userId
    parents
    invitations {
         _id
        fromId
        invitationType
        invitationToType
        toId
        status
        context { 
                message
                itemId
                itemType
        }
     }
    }
`;
export const GET_USER_PROFILES_SA = `
 ${PROFILE_WITH_INVITATIONS}
  query GetClubProfilesSA($userId: String){
   getClubProfilesSA(userId:  $userId) {
      ...profileWithInvitation
    }
}`;

export const RESOLVE_CLUBS = `
  query ($ids: [String]){
   ResolveClubs(ids:  $ids) {
      _id
      name
      abbreviation
      logo
      clubAdminUsers
      location {
        address
        coordinates
      }
      founded
      country
      sport
      contactInfo {
        phones
        emails
        websiteUrl
      }
      isPremium
      timezone
      theme
      totalMembers
    }
}`;

export const USER_WITH_INVITATIONS_FIELDS = `
  fragment userFields on UserWithInvitations {
    _id
    mobile
    email
    firstName
    lastName
    roles
    invitations {
         _id
        fromId
        invitationType
        invitationToType
        status
        toId
        context { 
                message
                itemId
                itemType
        }
    }
    clubs {
       _id
       name
       abbreviation
       isPremium
     }
    teams {
     _id
     name
     club {
       _id
       abbreviation
       name
       isPremium
     }
     teamAdminUsers
     coaches
     teamCode
    }
  }
`;

export const SEARCH_USER_WITH_MOBILE_SA = `
 ${USER_WITH_INVITATIONS_FIELDS}
  query SearchUserWithMobileSA($mobile: String!) {
    searchUserWithMobileSA(mobile: $mobile) { 
      ...userFields
    }
  } 
`;

export const GET_ROLES_SA = `
  query {
    getRolesSA {
      role
      permissions
    }
  }
`;

export const EDIT_ROLE_PERMISSIONS_SA = `
  mutation EditRolePermissionsSA($role: String!, $permissions: [String!]!) {
    editRolePermissionsSA(role: $role, permissions: $permissions) {
      role
      permissions
    }
  }
`;

export const GET_PERMISSIONS_SA = `
query {
  getPermissionsSA {
    name
    description
  }
}
`;
